import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';
export function useProjects() {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        fetchProjects();
    }, []);
    const fetchProjects = async () => {
        try {
            setLoading(true);
            const { data, error } = await supabase
                .from('projects')
                .select('*')
                .eq('status', 'published')
                .order('created_at', { ascending: false });
            if (error)
                throw error;
            setProjects(data || []);
        }
        catch (err) {
            console.error('Error fetching projects:', err);
            setError('施工実績の取得に失敗しました。');
        }
        finally {
            setLoading(false);
        }
    };
    return { projects, loading, error, refetch: fetchProjects };
}
export function useProject(slug) {
    const [project, setProject] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (slug) {
            fetchProject(slug);
        }
    }, [slug]);
    const fetchProject = async (slug) => {
        try {
            setLoading(true);
            const { data, error } = await supabase
                .from('projects')
                .select('*')
                .eq('slug', slug)
                .eq('status', 'published')
                .maybeSingle();
            if (error)
                throw error;
            setProject(data);
        }
        catch (err) {
            console.error('Error fetching project:', err);
            setError('施工実績の取得に失敗しました。');
        }
        finally {
            setLoading(false);
        }
    };
    return { project, loading, error, refetch: () => fetchProject(slug) };
}
